export default {
    title: '수업 결과',

    sessionInfo: {
        title: '수업 정보',
        items: {
            date: '수업일',
            duration: '수업시간',
            studentCount: '참여 학생 수',
            curriculum: '교육과정',
        },
        durationFormat: '{startTime} ~ {endTime} ({duration}분)',
    },

    summary: {
        title: '활동 요약',
        headers: {
            activity: '활동',
            mode: '모드',
            time: '시간',
            result: '결과',
        },
    },

    studentResults: {
        title: '학생별 정답 개수 및 MVP',
        mvp: 'MVP',
        headers: {
            student: '학생',
            answers: '정답 수',
            score: '점수',
        },
    },

    actions: {
        close: '창 닫기',
        print: '인쇄하기',
        export: '내보내기',
    },

    errors: {
        windowClose: '오류가 발생했습니다. 창을 직접 닫아주세요.',
    },
};
